// ----------------------------------------------------------------------------
// Snippet: Mini Cart
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import { lineItemCardHtml }   from 'snippets/cart-js/ajax-add-cart';
import { cartSubtotalUpdate } from 'snippets/cart-js/ajax-add-cart';
import 'snippets/cart-js/cart-js';
import 'snippets/card/card';

// Styles
import './_mini-cart.scss';

const MINI_CART_ITEM_DROPDOWN = '.mini-cart__item--dropdown';
const MINI_CART_LINK = '.mini-cart__header-link';


Shopify.miniCart = () => {

    const _config = {
        itemsContainerSelector : '.mini-cart__items-container',
        itemsListSelector      : '.mini-cart__items-list',
        miniCartFooterSelector : '.mini-cart__footer',
        shopifyAjaxCartURL     : '/cart.js',
    };

    const _init = () => {

        const itemsContainer = document.querySelector(_config.itemsContainerSelector);
        const itemsList      = document.querySelector(_config.itemsListSelector);

        if ( itemsContainer ) {
            // Update cart count and cart modal.
            fetch(_config.shopifyAjaxCartURL, {
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then((cart) => {
                    if (cart.items.length) {

                        itemsList.innerHTML = '';
                        const cartItems = cart.items;
                        cartItems.forEach((value) => {
                            lineItemCardHtml(value).then((lineItem) => {
                                if (itemsList) {
                                    itemsList.innerHTML += `<li class="mini-cart__line-item">${lineItem}</li>`;
                                }
                            });
                        });
                    } else {
                        itemsList.innerHTML = '';
                        itemsList.innerHTML = `<li class='mini-cart__line-item'>${window.translations.cartEmpty}</li>`;
                    }

                    // Update cart subtotal and items
                    cartSubtotalUpdate(cart);
                });
        }
    };
    return {
        init: (params) => {
            // Configuration
            params = params || {};
            // Merging with defaults.
            Object.assign(_config, params);
            // Action
            _init();
        },
        getConfig: () => {
            return _config;
        }
    };
};

Shopify.miniCart().init();

document.addEventListener('DOMContentLoaded', () => {

    const miniCartItemDropdown = document.querySelector(MINI_CART_ITEM_DROPDOWN);
    const miniCartLink = document.querySelector(MINI_CART_LINK);
    
    if (!miniCartItemDropdown || !miniCartLink) {
        return false;
    }

    miniCartItemDropdown.addEventListener('focusin', () => {
        if (!miniCartItemDropdown.classList.contains('js--is-open')) {
            miniCartItemDropdown.classList.add('js--is-open');
            const tabIndexItems = miniCartItemDropdown.querySelectorAll('[tabindex="-1"]');
            tabIndexItems.forEach((tabIndexItem) => {
                tabIndexItem.setAttribute('tabindex', '0');
            });
        }
    });

    miniCartItemDropdown.addEventListener('focusout', () => {
        if (miniCartItemDropdown.classList.contains('js--is-open')) {
            miniCartItemDropdown.classList.remove('js--is-open');
        }
    });



    miniCartItemDropdown.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && miniCartItemDropdown.classList.contains('js--is-open')) {
            miniCartLink.focus();
            miniCartItemDropdown.classList.remove('js--is-open');
        }
    });
});


